import { debugLog, logDataInternally, transformParamsForDebugLog } from "./utils";
import { yandexMetricService } from "OK/metrics/YandexMetricService";
import { myTrackerService } from "OK/metrics/MyTrackerService";
import { parseJsonConf } from "OK/utils/parseJsonConf";

const logRender = (serviceName: string, logPrefix: string, param2: string): void => {
    const eventName = 'script:load';
    debugLog(serviceName, `script has been loaded! Sending with param1: "${eventName}" event and param2: "${param2}"`);
    logDataInternally(logPrefix, serviceName, eventName, param2);
};

const logError = (serviceName: string): void => {
    debugLog(serviceName, 'script has NOT been loaded!')
};

/**
 * Модуль логирует факт загрузки метрик с доп информацией о возможных причинах.
 */
export const activate = (element: HTMLElement): void => {
    const yaMetricsScriptId = element.dataset.yaMetricsScriptId;
    const myTrackerScriptId = element.dataset.myTrackerScriptId;
    const loadReasons = transformParamsForDebugLog(parseJsonConf(element, 'data-load-reasons')!);

    ([
        [yandexMetricService.logPrefix, yandexMetricService.serviceName, yaMetricsScriptId, () => window.ym],
        [myTrackerService.logPrefix, myTrackerService.serviceName, myTrackerScriptId, () => window._tmr]
    ] as [string, string, string, () => any][])
        .forEach(([logPrefix, serviceName, scriptId, getLoadedExecutor]) => {
            try {
                if (typeof getLoadedExecutor() !== 'undefined') {
                    logRender(serviceName, logPrefix, loadReasons);
                } else {
                    const scriptElement = document.getElementById(scriptId);

                    if (scriptElement) {
                        scriptElement.addEventListener('load', () => logRender(serviceName, logPrefix, loadReasons));
                        scriptElement.addEventListener('error', () => logError(serviceName));
                    } else {
                        logError(serviceName);
                    }
                }
            } catch (e) {
                console.warn('Some error occurred while logging metrics loading!', e);
            }
        });
}
